import { isEmpty, isNone } from '@ember/utils';
import NewSnippetPage from 'cio/components/new-snippet-page';
import SnippetSettingsItemComponent from 'cio/components/snippet-item';

const MAX_NAME_LENGTH = 150;

export default {
  name(this: NewSnippetPage | SnippetSettingsItemComponent, value?: string | null) {
    if (isNone(value) || isEmpty(value.trim())) {
      return 'A name must be provided';
    }

    if (value.length > MAX_NAME_LENGTH) {
      return `Snippet names can't be longer than ${MAX_NAME_LENGTH.toLocaleString()} characters`;
    }

    return true;
  },

  value(value?: string | null) {
    if (isNone(value) || isEmpty(value.trim())) {
      return 'A snippet must be provided';
    }

    return true;
  },
};
